var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page noScroll"},[_c('div',{staticClass:"page-content infinite-scroll noScroll"},[_c('Contact',{attrs:{"nationTip":_vm.userInfo.nationality === '中国' ? '必填' : '选填'},on:{"on-save":_vm.save}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }